const TOKEN_KEY = 'auth_token';

/**
 * Get the authentication token from sessionStorage (CON-3585).
 * @returns {string|null} The stored token or null if not found
 */
export const getAuthToken = () => {
	try {
		return sessionStorage.getItem(TOKEN_KEY);
	} catch (error) {
		console.error('Error retrieving auth token:', error);
		return null;
	}
};

/**
 * Set the authentication token in sessionStorage (CON-3585).
 * @param {string} token - The JWT token to store
 */
export const setAuthToken = (token) => {
	try {
		if (token) {
			sessionStorage.setItem(TOKEN_KEY, token);
		}
	} catch (error) {
		console.error('Error storing auth token:', error);
	}
};

/**
 * Remove the authentication token from sessionStorage (and legacy localStorage).
 */
export const removeAuthToken = () => {
	try {
		sessionStorage.removeItem(TOKEN_KEY);
		localStorage.removeItem(TOKEN_KEY);
	} catch (error) {
		console.error('Error removing auth token:', error);
	}
};

/**
 * Get authorization headers with Bearer token
 * @returns {Object} Headers object with Authorization if token exists
 */
export const getAuthHeaders = () => {
	const token = getAuthToken();
	if (token) {
		return {
			'Authorization': `Bearer ${token}`
		};
	}
	return {};
};
